export const LINK_LIST_REQUEST = "LINK_LIST_REQUEST";
export const LINK_LIST_SUCCESS = "LINK_LIST_SUCCESS";
export const LINK_STATS_REQUEST = "LINK_STATS_REQUEST";
export const LINK_STATS_SUCCESS = "LINK_STATS_SUCCESS";
export const LINK_CREATE_REQUEST = "LINK_CREATE_REQUEST";
export const LINK_CREATE_SUCCESS = "LINK_CREATE_SUCCESS";
export const LINK_URL_AVAILABLE = "LINK_URL_AVAILABLE";
export const LINK_SLUG_AVAILABLE = "LINK_SLUG_AVAILABLE";
